/* List of modals in alphabetical order */
/* eslint-disable camelcase, max-len */

// Bonus
export { default as mt_bonusButton } from 'core/modules/BonusButton/components/BonusButtonModal/BonusButtonModal';

// Instore
export { default as mt_instoreAddNewCard2 } from 'core/modules/Instore2/components/Modals/AddNewCardModal/AddNewCardModal';
export { default as mt_instoreManageCards2 } from 'core/modules/Instore2/components/Modals/ManageCardsModal/ManageCardsModal';
export { default as mt_instoreOffer2 } from 'core/modules/Instore2/components/Modals/InstoreOfferModal/InstoreOfferModal';
